import React from "react";
import { useHistory } from "react-router-dom";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";

export const AntiguedadInventarioItem = ({ data, sucursales }) => {
  const history = useHistory();
  const GetClass = (value, minimo = 20, medium = 81) => {
    if (value <= minimo) return "circle-red";
    else if (value <= medium) return "circle-yellow";
    else return "circle-success";
  };
  const handleClickAntiguedadInventario = () => {
    history.push("/Finanzas/AntiguedadIntentario", sucursales);
  };

  // console.log(data?.inventarioAntiguedad)
  const inventario = data?.inventarioAntiguedad

  const formatmiles = (number) => {
    return Math.floor((number ?? 0) / 1000).toLocaleString('en-US');
  };

  const calcularporcentaje = (param, ventasNetas) => {
    if (!ventasNetas) return 0;
    return ((param / ventasNetas) * 100).toFixed(2);
  };

  return (
    <div className="dashboard-financiero-container-box" onClick={handleClickAntiguedadInventario}>
      <div className="dashboard-financiero-container-box-titulo">
        Antigüedad de Inventario
      </div>
      <div className="dashboard-financiero-container-box-info df_box_antiguedad_inventario">
        <table cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              <td></td>
              <td>Dias</td>
              <td>Meses</td>
              <td>Costo</td>
            </tr>
          </thead>
          <tbody>
            {inventario.map((item, index) => (
              <tr key={index}>
                <td>
                  {item.familia.toLowerCase() === 'john deere water'
                    ? 'Sistemas de Riego'
                    : capitalizePalabras(item.familia)}
                </td>
                <td className="ta-center">{item.promedio_AntiguedadDias}</td>
                <td className="ta-center">{item.promedio_Meses}</td>
                <td className="ta-center">{formatmiles(item.suma_Costo)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
